<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('myapplication.title') }}
        <Bookmark service_type_code='6431' />
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('myapplication.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.list') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <div class="top__component__fold__wrap" v-if="component_fold">
            <v-row class="top_search_content2">
              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myapplication.fields.application') }}</label>
                <v-select
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type1"
                  :items="$vuetify.rtl ? applicationTypeCodeArList : applicationTypeCodeEnList"
                  v-model="search.search_application_type_code"
                  @change="fnGetStatusCodeInitList()"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type1"
                  :items="($vuetify.rtl) ? statusCodeListAr : statusCodeListEn"
                  v-model="search.search_application_status_seq"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myapplication.fields.stage') }}</label>
                <v-select
                  dense
                  solo
                  flat
                  outlined
                  hide-details
                  class="type1"
                  :items="$vuetify.rtl ? stageTypeCodeListAr : stageTypeCodeListEn"
                  v-model="search.search_stage_type_code"
                >
                </v-select>
              </v-col>
            </v-row>

            <v-row class="top_search_content2">
              <v-col cols="12" md="4">
                <label class="nec_title">{{$t('myapplication.fields.date_type')}}</label>
                <v-select
                  dense
                  solo
                  flat
                  outlined
                  hide-details
                  class="type2"
                  :items="dateTypeList"
                  v-model="search.search_date"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="8" class="d-flex align-center mobile__dcolumn">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      flat
                      solo
                      dense
                      outlined
                      readonly
                      hide-details
                      v-on="on"
                      v-bind="attrs"
                      v-model="viewDate1"
                      @click:append="menu1 = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="date1" no-title @input="fnSetStartDate()"></v-date-picker>
                </v-menu>
                <v-spacer class="hidden_lr10 text-center">~</v-spacer>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      flat
                      solo
                      dense
                      outlined
                      readonly
                      hide-details
                      v-on="on"
                      v-bind="attrs"
                      v-model="viewDate2"
                      @click:append="menu2 = true"
                    ></v-text-field>
                  </template>
                  <v-date-picker :min="date1" v-model="date2" no-title @input="fnSetEndDate()"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-row class="top_search_content2 wt_type2">
              <v-col cols="12" md="4">

                <v-select
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type2"
                  style="background:#fbf3f4"
                  :items="keyList"
                  v-model="search.search_key"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  solo
                  flat
                  dense
                  hide-details
                  outlined
                  class="type5"
                  v-model="search.search_keyword"
                >
                </v-text-field>

              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">
                  {{ $t('myapplication.fields.title') }}
                </label>
                <v-text-field
                  solo
                  flat
                  dense
                  hide-details
                  outlined
                  v-model="search.search_title"
                >
                </v-text-field>
              </v-col>
            </v-row>

            <v-row class="top_search_content2">
              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myapplication.fields.applicant_type') }}</label>
                <v-select
                  solo
                  flat
                  dense
                  hide-details
                  outlined
                  :items="$vuetify.rtl ? applicantTypeCodeArList : applicantTypeCodeEnList"
                  v-model="search.search_applicant_type_code"
                >
                </v-select>
              </v-col>

              <v-col cols="12" md="4">
                <label class="nec_title">{{ $t('myapplication.fields.applicant') }}</label>
                <v-text-field
                  solo
                  flat
                  dense
                  outlined
                  hide-details
                  class="type5"
                  v-model="search.search_applicant"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" md="4" class="mobile__dcolumn">
                <v-btn class="t_search_btn wp50" color="#a01c2a" dense dark @click="fnGetDataFromApi(1)">
                  <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.search') }}
                </v-btn>
                <v-spacer class="hidden_lr5 d-inline-flex"></v-spacer>
                <v-btn class="t_search_btn wp50" color="#222" dense dark @click="fnReset()">
                  <v-icon>mdi-restart</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('common.button.reset') }}
                </v-btn>
              </v-col>
            </v-row>

            <!-- 여긴 예제일뿐 번역 대상 아님. -->
            <v-row class="ma-0 chip_line_wrap mt-25">
              <v-col class="pa-0 chip_bar">
                <v-chip v-for="(item, index) in bookmarkList" v-bind:key="index" outlined color="#cf8d94" @click="selectBookmark(item.search_keyword)" close @click:close="deleteBookmark(item.seq)">
                  <v-icon color="#a01c2a">mdi-star</v-icon>
                  {{item.name}}
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn class="add_ft_btn" dark rounded color="#ff5f29" @click="bookmark_dialog = true">
                  <v-icon>mdi-filter</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                  {{ $t('myapplication.fields.add_this_filter') }}
                </v-btn>
              </v-col>
            </v-row>
          </div>

          <!-- 상단 레이아웃 접는 기능영역 : S -->
          <div class="fold__actions__wrap">
            <v-btn @click="foldingActions()" :class="{actv : component_fold}" color="#dedede" small min-width="120px"><v-icon x-small color="#727272">mdi-triangle</v-icon></v-btn>
          </div>
          <!-- 상단 레이아웃 접는 기능영역 : E -->

          <v-row class="ma-0 mt-30">
            <v-col cols="12" class="pa-0">
              <v-data-table
                :custom-sort="$customSort"
                :headers="$getHeaderType2(headerTxt, headers_en, headers_ar)"
                :items="myApplicationList"
                hide-default-footer
                :options.sync="options"
                :server-items-length="paging.totalCount"
                class="new__type__table ty2"
                :mobile-breakpoint="MobileBreakPoint"
              >
                <template v-slot:item="{ item }">
                  <tr :style="{ 'background-color': (item.user_seq != user_seq) ? '#f4f4f4':''}">
                    <td colspan="6" class="org__tbl__db__line">
                      <div class="tbl__db__line__layout__wrap">
                        <div class="tbl__db__line__layout">
                          <div class="top__data">
                            <div class="actv__text" :class="$vuetify.rtl ? 'text-right' : 'text-left'">
                              {{ item.application_no }}
                              <span v-if="!(item.application_no)" style="color:#a01c2a;font-weight:bold;">({{ item.application_receipt_no }})</span>
                            </div>
                            <div class="actv__text" @click="fnGoMyAppDetail(item)" style="cursor:pointer;">{{ item.filing_date }}</div>
                            <div>
                              <span class="mr-15" @click="fnGoMyAppDetail(item)" style="cursor:pointer;">{{ item.grant_no }}</span>
                              <v-icon color="#FF0000" v-if="item.certification_ar_file_key" @click="fnShowCertFile(item)">mdi-certificate</v-icon>
                              <v-icon v-if="item.grant_no && !item.certification_ar_file_key" @click="fnShowCertFile(item)">mdi-certificate</v-icon>
                            </div>
                            <div @click="fnGoMyAppDetail(item)" style="cursor:pointer;">{{ item.grant_date }}</div>
                          </div>
                          <div class="btm__data" :class="$vuetify.rtl ? 'text-right' : 'text-left'" @click="fnGoMyAppDetail(item)" style="cursor:pointer;">
                            {{ $vuetify.rtl ? item.title_ar : item.title_en }}
                          </div>
                        </div>
                        <div class="status__data__lgd" @click="fnGoMyAppDetail(item)" style="cursor:pointer;">
                          {{ $vuetify.rtl ? item.status_name_ar : item.status_name_en }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <div class="v-data-table-footer page_nation_wrap mt-20">
                <ServerPagination
                  :paging.sync="paging"
                  @page="fnGoPage"
                  @pageSize="fnSetPageSize"
                />
              </div>

            </v-col>
          </v-row>
        </v-flex>
      </v-layout>
    </v-layout>

    <v-dialog  v-model="compnonent_dialog" flat persistent max-width="900" content-class="br_none">
      <v-card class="br_none modal_comfirm_wrap type4 pb-0">
        <v-btn class="modal_close" @click="compnonent_dialog = false" fab color="white">
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
        <h2 class="header_title02 type4">{{$t('myapplication.fields.certification')}}</h2>
      </v-card>
      <v-layout class="login_wrap type2 modal_type ma-0 pb-5">
        <v-flex class="pl-5 pr-5 pt-0 ma-0 login_content type2">
          <pdf-viewer height="550px" :url="pdfUrl"></pdf-viewer>
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="bookmark_dialog" flat persistent max-width="350" content-class="br_none">
      <ValidationObserver ref="observer">
        <v-form>
          <v-card>
            <v-card-title class="headline">{{$t('myapplication.fields.add_this_filter')}}</v-card-title>
            <v-card-text>
              <ValidationProvider v-slot="{ errors }" :name="$t('myapplication.fields.add_this_filter')" :rules="{required: true}">
                <v-text-field
                  dense
                  outlined
                  clearable
                  class="ft-size12"
                  v-model="bookmarkName"
                  :error-messages="errors"
                >
                </v-text-field>
              </ValidationProvider>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="sb_btn btn-actv" @click="setBookmark()">{{ $t('common.button.yes') }}</v-btn>
              <v-btn class="sb_btn btn-dactv" @click="bookmark_dialog = false">{{ $t('common.button.no') }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </ValidationObserver>
    </v-dialog>

  </v-container>
</template>
<script>
import ServerPagination from '@/components/layout/ServerPagination'
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import PdfViewer from '@/components/layout/PdfViewer.vue'
import store from '@/store'
import Bookmark from '@/components/layout/Bookmark'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name : 'myapplication-list',
  components :{
    Bookmark,
    ServerPagination,
    PdfViewer,
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      MobileBreakPoint:0,
      component_fold : false,
      compnonent_dialog : false,
      bookmark_dialog : false,

      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },
      options: {},
      headerTxt : {
        prefix : 'myapplication.fields.',
        txt : [ 'application_no','filing_date','grant_no','grant_date','status' ]
      },
      headers_ar: [
        { width : '18%', text: '', align: 'right', value : 'application_no'},
        { width : '18%', text: '', align: 'center', value : 'filing_date' },
        { width : '18%', text: '', align: 'center', value : 'grant_no' },
        { width : '18%', text: '', align: 'center', value : 'grant_date' },
        { width : '28%', text: '', align: 'center', value : 'status_name_ar' }
      ],
      headers_en: [
        { width : '18%', text: '', align: 'left', value : 'application_no'},
        { width : '18%', text: '', align: 'center', value : 'filing_date' },
        { width : '18%', text: '', align: 'center', value : 'grant_no' },
        { width : '18%', text: '', align: 'center', value : 'grant_date' },
        { width : '28%', text: '', align: 'center', value : 'status_name_en' }
      ],
      myApplicationList : [],

      search : {
        search_application_type_code : '',
        search_date : 'grant_date',
        search_start_date : '',
        search_end_date : '',
        search_key : 'application_no',
        search_keyword : '',
        search_applicant : '',
        search_title : '',
        search_stage_type_code: '',
        search_applicant_type_code : '',
        search_application_status_seq : ''
      },

      applicationTypeCodeArList : [],
      applicationTypeCodeEnList : [],
      applicantTypeCodeArList : [],
      applicantTypeCodeEnList : [],
      stageTypeCodeListAr: [],
      stageTypeCodeListEn: [],

      menu1 : false,
      menu2 : false,
      date1 : null,
      date2 : null,
      viewDate1 : '',
      viewDate2 : '',

      statusCodeListAr : [
        { value : '', text : 'جميع'}
      ],
      statusCodeListEn : [
        { value : '', text : 'All'}
      ],

      downLoadUrl : process.env.VUE_APP_BASE_URL + '/file/download/',
      pdfUrl: '',
      user_seq: null,
      bookmarkName: '',
      bookmarkList: [],

      searchParams: {}
    }
  },
  computed: {
    dateTypeList () {
      let list = [
        {value : 'grant_date', text : this.$t('myapplication.fields.grant_date')},
        {value : 'filing_date', text : this.$t('myapplication.fields.filing_date')}
      ]

      return list
    },
    keyList () {
      let list = [
        {value : 'application_no', text : this.$t('myapplication.fields.application_no')},
        {value : 'grant_no', text : this.$t('myapplication.fields.grant_no')},
        {value : 'pct_application_no', text : this.$t('myapplication.fields.pct_application_no')},
      ]

      return list
    }
  },
  watch: {
    options: {
      handler () {
        this.fnGetDataFromApi()
      },
      deep: true,
    },
  },
  mounted(){
    window.scrollTo(0, 0)
    // 폴딩 브라우저 사이즈 체크 하여 접고 여는 부분 체크
    this.onResize()
    //window.addEventListener('resize', this.onResize, { passive: true })


    //넘겨받은 쿼리스트링을 검색 파라메터에 삽입
    let param = utils.qryStrToJson(location.href)
    if(param){
      if (param.search_application_type_code) this.search.search_application_type_code = param.search_application_type_code
      if (param.search_date) this.search.search_date = param.search_date
      if (param.search_start_date) this.search.search_start_date = param.search_start_date
      if (param.search_end_date) this.search.search_end_date = param.search_end_date
      if (param.search_key) this.search.search_key = param.search_key
      if (param.search_keyword) this.search.search_keyword = param.search_keyword
      if (param.search_applicant) this.search.search_applicant = param.search_applicant
      if (param.search_title) this.search.search_title = param.search_title
      if (param.search_stage_type_code) this.search.search_stage_type_code = param.search_stage_type_code
      if (param.search_applicant_type_code) this.search.search_applicant_type_code = param.search_applicant_type_code

      if (param.search_application_status_seq) {
        this.search.search_application_status_seq = parseInt(param.search_application_status_seq, 10)
      } else {
        this.search.search_application_status_seq = ''
      }

      let keys = Object.keys(param)
      for (let i = 0; i < keys.length; i++) {
        this[keys[i]] = param[keys[i]]

        if (keys[i] === 'page') {
          this.options.page = (param[keys[i]]) ? parseInt(param[keys[i]], 10) : 1
        } else if (keys[i] === 'page_size') {
          this.options.itemsPerPage = (param[keys[i]]) ? parseInt(param[keys[i]], 10) : 10
        } else if (keys[i] === 'sort_by') {
          if (param[keys[i]]) {
            this.options.sortBy[0] = param[keys[i]]
          }
        } else if (keys[i] === 'sort_desc') {
          if (param[keys[i]]) {
            this.options.sortDesc[0] = param[keys[i]]
          }
        }
      }

      this.date1 = this.formatDate2(this.search.search_start_date)
      this.date2 = this.formatDate2(this.search.search_end_date)
      this.viewDate1 = this.search.search_start_date
      this.viewDate2 = this.search.search_end_date
    }
    this.fnGetStatusCodeList()
    this.fnInit()
  },
  beforeDestroy (){
    // 리사이징 이벤트 제거
    if (typeof window === 'undefined') {
      return
    }
    window.removeEventListener('resize', this.onResize, { passive: true });
  },
  methods: {
    onResize () {
      this.component_fold = window.innerWidth < 960 ? false : true
    },
    foldingActions(){
      this.component_fold = !this.component_fold
    },
    fnInit(){
      let options = {
        upper_code: '8910',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.applicationTypeCodeArList = list.ar
        this.applicationTypeCodeEnList = list.en
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      options = {
        upper_code: '2700',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.applicantTypeCodeArList = list.ar
        this.applicantTypeCodeEnList = list.en
      }).catch((res)=>{
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      options = {
        upper_code: '1100',
        all: true
      }
      utils.fnGetCodeList(options).then(list => {
        this.stageTypeCodeListAr = list.ar
        this.stageTypeCodeListEn = list.en
      }).catch(res => {
        eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
      })

      this.user_seq = store.state.token.user_seq

      this.getBookmark()
    },

    fnShowCertFile(item){
      if (item.certification_ar_file_key) {
        this.pdfUrl = this.downLoadUrl + item.certification_ar_file_key +'/pdf/'+ item.certification_ar_file_name
        this.compnonent_dialog = true
      } else {
        let option = {
          text : this.$t('common.message.certification_error'),
        }
        eventBus.$emit('SHOW_SNACKBAR', option)
      }
    },

    fnGoPage(paging) {
      this.options.page = paging.page
      this.options.itemsPerPage = paging.pageSize
    },

    fnSetPageSize(paging) {
      // 페이지당 목록 개수를 변경할 경우에는 1페이지로 이동
      this.options.page = 1
      this.options.itemsPerPage = paging.pageSize
    },

    fnGetDataFromApi (page) {
      if (page) {
        this.options.page = page
        if (page === 1) {
          this.searchParams = {}
        }
      }
      this.fnGetMyAppList().then(list => {
        this.myApplicationList = list
        this.paging.totalCount = 0
        if (list.length > 0) {
          this.paging.totalCount = list[0].total_cnt
        }
        this.paging.pageCount = parseInt((this.paging.totalCount - 1) / this.paging.pageSize, 10) + 1
      }).catch(() => {
        this.searchParams = {}
        this.fnGetDataFromApi(page)
      })
    },

    fnGetMyAppList(){
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        this.paging.page = this.options.page

        let params = {
          search_application_type_code: this.search.search_application_type_code,
          search_date: this.search.search_date,
          search_start_date: this.search.search_start_date,
          search_end_date: this.search.search_end_date,
          search_key: this.search.search_key,
          search_keyword: this.search.search_keyword,
          search_applicant: this.search.search_applicant,
          search_title: this.search.search_title,
          search_stage_type_code: this.search.search_stage_type_code,
          search_applicant_type_code: this.search.search_applicant_type_code,
          search_application_status_seq: this.search.search_application_status_seq,
          page: this.options.page,
          page_size: this.options.itemsPerPage,
          sort_by: (this.options.sortBy.length > 0) ? this.options.sortBy[0] : '',
          sort_desc: (this.options.sortDesc.length > 0) ? this.options.sortDesc[0] : ''
        }

        if (params.search_start_date) {
          params.search_start_date = this.$moment(this.search.search_start_date, 'DD-MM-YYYY').format('DD/MM/YYYY')
        }
        if (params.search_end_date) {
          params.search_end_date = this.$moment(this.search.search_end_date, 'DD-MM-YYYY').format('DD/MM/YYYY')
        }

        if (Object.entries(params).toString() === Object.entries(this.searchParams).toString()) {
          return false
        }

        this.searchParams = params
        requestApi({
          url: '/applications',
          method: 'GET',
          data : params,
          callback: (res) => {
            if (res.res_code === '200') {
              resolve(res.data.list)
            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  reject()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      })
    },
    fnReset(){
      //파라미터 초기화
      this.search.search_application_type_code = ''
      this.search.search_date = 'grant_date'
      this.search.search_start_date = ''
      this.search.search_end_date = ''
      this.search.search_key = 'application_no'
      this.search.search_keyword = ''
      this.search.search_applicant = ''
      this.search.search_title = ''
      this.search.search_stage_type_code = ''
      this.search.search_applicant_type_code = ''
      this.search.search_application_status_seq = ''

      let listAr = [
        { value : '', text : 'جميع'}
      ]
      let listEn = [
        { value : '', text : 'All'}
      ]
      this.statusCodeListAr = listAr
      this.statusCodeListEn = listEn

      // 달력 초기화
      this.date1 = null
      this.date2 = null
      this.viewDate1 = ''
      this.viewDate2 = ''

      this.options.sortBy = []
      this.options.sortDesc = []

      this.searchParams = {}

      if (this.options.page === 1 && this.options.itemsPerPage === 10) {
        this.fnGetDataFromApi(1)
      } else {
        this.options.page = 1
        this.options.itemsPerPage = 10
      }
    },
    fnSetStartDate(){
      this.viewDate1 = this.formatViewDate(this.date1)
      this.menu1 = false
      // 저장객체에 날짜 세팅
      this.search.search_start_date = this.formatDate(this.date1)

      this.fnSetMinDate()
    },
    fnSetEndDate(){
      this.viewDate2 = this.formatViewDate(this.date2)
      this.menu2 = false
      // 저장객체에 날짜 세팅
      this.search.search_end_date = this.formatDate(this.date2)
    },
    fnSetMinDate(){
      if(!utils.isNull(this.date2)){
        let start = this.date1.split('-')
        let end = this.date2.split('-')

        let startDate = new Date()
        startDate.setFullYear(start[0])
        startDate.setMonth(Number(start[1]) - 1)
        startDate.setDate(start[2])

        let endDate = new Date()
        endDate.setFullYear(end[0])
        endDate.setMonth(Number(end[1]) - 1)
        endDate.setDate(end[2])

        if(endDate < startDate){
          this.date2 = this.date1
          this.viewDate2 = this.formatViewDate(this.date1)
          this.saerch.search_end_date = this.formatDate(this.date1)
        }
      }
    },
    formatViewDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDate (date) {
      if (!date) return ''
      const [year, month, day] = date.split('-')
      return `${day}-${month}-${year}`
    },
    formatDate2 (date) {
      if (!date) return ''
      const [day, month, year] = date.split('-')
      return `${year}-${month}-${day}`
    },
    fnGoMyAppDetail(item){
      let qryStr = utils.jsonToQryStr(this.search)
      qryStr += '&page='+ this.options.page
      qryStr += '&page_size='+ this.options.itemsPerPage
      qryStr += '&sort_by='+ ((this.options.sortBy.length > 0) ? this.options.sortBy[0] : '')
      qryStr += '&sort_desc='+ ((this.options.sortDesc.length > 0) ? this.options.sortDesc[0] : '')

      this.$router.push({path : '/myapplication/view/' + item.seq + qryStr})
    },
    fnIsNull(val){
      return utils.isNull(val)
    },
    fnGetStatusCodeInitList() {
      this.search.search_application_status_seq = ''
      this.fnGetStatusCodeList()
    },
    fnGetStatusCodeList(){
      if(this.search.search_application_type_code == ''){
        this.statusCodeListAr = [{ text : 'جميع', value : "" }]
        this.statusCodeListEn = [{ text : 'All', value : "" }]
      }else{
        requestApi({
          url: '/workflow/' + this.search.search_application_type_code + '/status',
          method: 'GET',
          callback: (res) => {
            if (res.res_code === '200') {
              this.statusCodeListAr = [{ text : 'جميع', value : "" }]
              this.statusCodeListEn = [{ text : 'All', value : "" }]

              for (let i = 0; i < res.data.list.length; i++) {

                let item = res.data.list[i]
                let statusEnItem = {
                  text : item.name_en,
                  value : item.seq
                }
                this.statusCodeListEn.push( statusEnItem )

                let statusArItem = {
                  text : item.name_ar,
                  value : item.seq
                }
                this.statusCodeListAr.push( statusArItem )
              }
            } else {
              if (res.res_code === '401012') {
                utils.setTokenRefresh().then(() => {
                  this.fnGetStatusCodeList()
                })
              } else {
                eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
              }
            }
          }
        })
      }
    },
    getBorder1(){
      let style = ''
      if(this.$vuetify.rtl){
        style = 'border-right:thin solid #0000001f;'
      }else{
        style = 'border-left:thin solid #0000001f;'
      }
      return style
    },
    getBorder2(){
      let style = ''
      if(!this.$vuetify.rtl){
        style = 'border-right:thin solid #0000001f;'
      }else{
        style = 'border-left:thin solid #0000001f;'
      }
      return style
    },
    getBookmark(){
      requestApi({
        url: '/user/application/bookmarks',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.bookmarkList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.getBookmark()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    setBookmark(){
      this.$refs.observer.validate().then((valid) => {
        if(valid){
          var objRequest = {}
          objRequest.search_keyword = JSON.stringify(this.search)
          objRequest.name = this.bookmarkName

          requestApi({
            url: '/user/application/bookmark',
            method: 'POST',
            data: objRequest,
            callback: (res) => {
              if (res.res_code === '200') {
                this.bookmark_dialog = false
                this.bookmarkName = ''
                this.$refs.observer.reset()
                this.getBookmark()

                let option = {
                  text : this.$t('common.message.add.success'),
                }
                eventBus.$emit('SHOW_SNACKBAR', option)
              } else {
                if (res.res_code === '401012') {
                  utils.setTokenRefresh().then(() => {
                    this.setBookmark()
                  })
                } else {
                  eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
                }
              }
            }
          })
        }
      })
    },
    deleteBookmark(seq){
      requestApi({
        url: '/user/application/bookmark/'+seq,
        method: 'DELETE',
        callback: (res) => {
          if (res.res_code === '200') {
            this.getBookmark()
            let option = {
              text : this.$t('common.message.delete.success'),
            }
            eventBus.$emit('SHOW_SNACKBAR', option)
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.deleteBookmark(seq)
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    selectBookmark(search_keyword){
      this.searchParams = {}
      this.search = JSON.parse(search_keyword)
      this.date1 = this.formatDate2(this.search.search_start_date)
      this.date2 = this.formatDate2(this.search.search_end_date)
      this.viewDate1 = this.search.search_start_date
      this.viewDate2 = this.search.search_end_date

      this.options.sortBy = []
      this.options.sortDesc = []

      if (this.options.page === 1 && this.options.itemsPerPage === 10) {
        this.fnGetDataFromApi(1)
      } else {
        this.options.page = 1
        this.options.itemsPerPage = 10
      }
    }
  }
}
</script>